import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SeatMapAvailability } from '@models/booking.models';
import { GrowthBookFeatureKeys } from '@models/growthbook.models';
import {
  N0BulkPassengerSeatRequest,
  N0PassengerSeatRequest,
} from '@models/requests/passenger-seat-request';
import { ApiResponse } from '@models/responses/api-response.model';
import { EnvironmentService } from '@services/environment-service/environment.service';
import { GrowthBookService } from '@services/growthbook/growthbook.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SeatService {
  private static readonly SEATMAPS_CONTROLLER_ROOT = 'v1/seatmaps';
  private static readonly SEATMAPS_CONTROLLER_ROOT_V2 = 'v1/seatmaps/v2';
  private static readonly SEATS_CONTROLLER_ROOT = 'v1/seats';
  private readonly gbf = GrowthBookFeatureKeys;

  constructor(
    private httpClient: HttpClient,
    private gbs: GrowthBookService,
  ) {}

  getSeatMaps(): Observable<ApiResponse<SeatMapAvailability[]>> {
    const isReducedAvailableSeats =
      this.IsReducedAvailableSeatsVariantCEnabled();

    return this.httpClient.get<ApiResponse<SeatMapAvailability[]>>(
      `${EnvironmentService.environment.apiBaseUrl}${isReducedAvailableSeats ? SeatService.SEATMAPS_CONTROLLER_ROOT_V2 : SeatService.SEATMAPS_CONTROLLER_ROOT}`,
    );
  }

  updatePassengerSeats(
    seatRequests: N0PassengerSeatRequest[],
  ): Observable<ApiResponse<null>> {
    return this.httpClient.post<ApiResponse<null>>(
      `${EnvironmentService.environment.apiBaseUrl}${SeatService.SEATS_CONTROLLER_ROOT}`,
      {
        seatRequests,
      } as N0BulkPassengerSeatRequest,
    );
  }

  private IsReducedAvailableSeatsVariantCEnabled(): boolean {
    return (
      this.gbs.growthBook.isOn(this.gbf.FEAT_US493_REDUCE_AVAILABLE_SEATS) &&
      this.gbs.growthBook.getFeatureValue(
        this.gbf.FEAT_US493_REDUCE_AVAILABLE_SEATS,
        '',
      ) === 'c'
    );
  }
}
